import React from 'react';
import './../../scss/components/dashboard-button.style.scss';

interface DashboardButtonProps {
  variant: 'primary' | 'secondary' | 'dropdown';
  children: React.ReactNode;
  onClick?: () => void;
  icon?: React.ReactNode;
  className?: string;
}

export const DashboardButton: React.FC<DashboardButtonProps> = ({
  variant,
  children,
  onClick,
  icon,
  className = ''
}) => {
  return (
    <button 
      className={`dashboard-button dashboard-button--${variant} ${className}`}
      onClick={onClick}
    >
      {children}
      {icon && <span className="dashboard-button__icon">{icon}</span>}
    </button>
  );
};
